import { Link, Outlet, createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { officeOpenTo } from '@regent/shared';
import { useMe } from '@/lib/queries';

export const Route = createFileRoute('/dev')({ component: DevGate });

/**
 * The development pages (the office design sandbox, the progress list, the email outbox) are behind
 * the same door as the office: platform admins only. Anyone signed out is sent to sign in; anyone
 * else gets a plain not-found page, as if the pages did not exist.
 */
function DevGate() {
  const me = useMe();
  const navigate = useNavigate();
  useEffect(() => {
    if (me === null) void navigate({ to: '/login', replace: true });
  }, [me, navigate]);
  if (me === undefined || me === null) return null;
  if (!officeOpenTo(me)) {
    return (
      <div className="flex h-full items-center justify-center">
        <div className="text-center">
          <p className="text-lg font-semibold text-fg">There is nothing here</p>
          <p className="mt-1 text-sm text-fg-muted">This page is not available.</p>
          <Link to="/" className="mt-4 inline-block text-sm text-accent-text underline">
            Go home
          </Link>
        </div>
      </div>
    );
  }
  return <Outlet />;
}
